import { render, staticRenderFns } from "./SetUp.vue?vue&type=template&id=3be54b4d"
import script from "./SetUp.vue?vue&type=script&lang=js"
export * from "./SetUp.vue?vue&type=script&lang=js"
import style0 from "./SetUp.vue?vue&type=style&index=0&id=3be54b4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports